// UserContext.js
import React, { createContext, useState, useContext } from "react";

const PricesContext = createContext();

export const PricesContextProvider = ({ children }) => {
    const [countedPrices, setCountedPrices] = useState({});

    const setAllCountedPrices = (id, price) => {
        setCountedPrices((prevPrices) => ({
          ...prevPrices,
          [id]: price,
        }));
      };
  return (
    <PricesContext.Provider value={{ countedPrices, setAllCountedPrices }}>
      {children}
    </PricesContext.Provider>
  );
};

export const UseItemPrices = () => {
  const context = useContext(PricesContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};
